import { Chrome as ChromeColorPicker } from 'vue-color'

export default {
  props:['value','totalPoint','editable'],
  data(){
    return {
      data:[],
      columns:[
        {
          type: 'index',
          width: 65,
          title: '序号',
          align: 'center'
        },
        {
          title: '等级名称',
          key: 'name',
          minWidth: 120,
        },
        {
          title: '色码',
          key: 'colorCode',
          minWidth: 100,
          render(h , {row}){
            return <ColorPicker value={row.color} view />
          }
        },
        {
          title: '等级范围',
          key: 'scoreMin',
          minWidth: 100,
          render(h , {row}){
            return <span>{row.scoreMin} ~ {row.scoreMax}</span>
          }
        },

      ]
    }
  },
  created(){
    if( this.editable !== false ){
      this.columns.push({
          title: '操作',
          key: 'action',
          width: 120,
          align: 'center',
          render: (h, {row , index}) => {
            if( this.editable === false ) return null

            let acts = []
            acts.push(
             <a on-click={()=>this.edit(row,index)}>编辑</a>,
             <a on-click={()=>this.remove(row,index)}>删除</a>
            )
   
            return this.$utils.link(acts,<Divider type="vertical" />)
          }
        })
    }
    
    let dataWatcher = this.$watch('value' , function(nv){
      if(nv && Array.isArray(nv) && !this.data.length){
        this.data = nv.map(i => ({
          scoreMin:i.scoreMin,
          scoreMax:i.scoreMax,
          name:i.name,
          color:i.color
        }))
        if(dataWatcher) dataWatcher()
      }
    },{immediate:true})
  },
  methods:{
    emit(){
      let publicData = this.data.map(i => ({...i}))
      this.$emit('input' , publicData)
    },
    remove(row , idx){
      this.data = this.data.filter((_,i) => i != idx)
      this.emit()
    },
    edit(row = {} , idx){

      let defaultData = {
        scoreMin:row.scoreMin,
        scoreMax:row.scoreMax,
        name:row.name,
        color:row.color
      }
      let disabledColor = this.data.map(i => i.color )
      if(row.color) {
        disabledColor = disabledColor.filter(i => i != row.color )
      }

      let disableScore = this.data.filter((_,i) => i != idx ).map(i => ([i.scoreMin,i.scoreMax]))


      this.$dialog({
        title:'等级设置',
        width:450,
        className:'paddingless',
        render:(h)=>{
          return <Panel disabled-color={disabledColor} disable-score={disableScore} default-data={defaultData} totalPoint={this.totalPoint} />
        },
        onOk:({data})=>{
          if(idx !== undefined){
            this.data.splice(idx,1,data)
          }else{
            this.data.push(data)
          }
          this.emit()
        }
      })
    },

  },
  render(){
    return <div>
      {
        this.editable !== false ? <Button size="small" icon="md-add" style="margin-bottom:8px;" on-click={()=>this.edit()} type="primary">新增</Button> : null
      }
      <sl-table page={false} columns={this.columns} data={this.data} />
    </div>
  }
}

const ColorPicker = {
  props:['value','view'],
  data(){
    return {
      currentValue:null
    }
  },
  created(){
    this.currentValue = this.value || '#000000'
    this.$watch('currentValue',function(){
      this.save()
    })
  },
  methods:{
    save(d){
      if( d ){
        this.currentValue = d.hex
        this.$emit('input',this.currentValue)
        this.$emit('change',this.currentValue)
      }
    }
  },
  render(){
    if( this.view ){
      return <div style={{width:"24px",height:"24px","backgroundColor":this.currentValue}}></div>
    }else{
      return <Poptip popper-class="sl-poptip-paddingless" placement="right">
        <div style={{width:"24px",height:"24px","backgroundColor":this.currentValue}}></div>
        <div slot="content">
          <ChromeColorPicker slot="content" on-input={this.save} value={this.currentValue} />
        </div>
      </Poptip>
    }
  }
}

const Panel = {
  props:['disabledColor' , 'defaultData' , 'totalPoint' , 'defaultMinPoint','disableScore'],
  created(){
    let defaultData = this.defaultData || {}
    this.state.scoreMin = defaultData.scoreMin || null
    this.state.scoreMax = defaultData.scoreMax || null
    this.state.color = defaultData.color || '#000000'
    this.state.name = defaultData.name
  },
  data(){
    return {
      state:{
        scoreMin:null,
        scoreMax:null,
        color:null,
        name:null
      },
    }
  },

  methods:{
    save(){
      if( this.check() !== false ){
        this.$emit('ok' , {...this.state})
      }
    },
    check(){
      let state = this.state
      if(!state.name){
        this.$Message.error('请输入等级名称')
        return false
      }
      if(!state.color){
        this.$Message.error('请选择颜色')
        return false
      }else{
        if( this.disabledColor && this.disabledColor.includes(state.color) ){
          this.$Message.error('此颜色已被使用，请选择其他颜色')
          return false
        }
      }

      if(state.scoreMin === undefined || state.scoreMax === undefined){
        this.$Message.error('请输入积分范围')
        return false
      }else{
        let disableScore = this.disableScore || []
        let { scoreMin , scoreMax } = state
        if( scoreMin >= scoreMax ){
          this.$Message.error('请输入正确的积分范围')
          return false
        }
        if( scoreMax > this.totalPoint ){
          this.$Message.error('请输入正确的积分范围')
          return false
        }
        for(let i = 0 ; i<disableScore.length;i++){
          if(
            scoreMin >= disableScore[i][0] && scoreMin <= disableScore[i][1] ||
            scoreMax >= disableScore[i][0] && scoreMax <= disableScore[i][1]

          ){
            this.$Message.error('此积分范围与已有的重复，请重新选择')
            return false
          }
        }
        
      }
    },
  },
  render(){
    let state = this.state
    return <div>
      <div class="modal-body">
        <sl-detail-list layout="vertical" col={1} labelAlign="right" label-width="100px">
          <sl-detail-list-item label="等级名称">
            <Input type="text" v-model={state.name}  />
          </sl-detail-list-item>
          <sl-detail-list-item label="色码">
            <ColorPicker v-model={state.color}  />
          </sl-detail-list-item>
          <sl-detail-list-item label="积分范围">
            <span class="sl-search-combo">
              <InputNumber min={0} max={this.state.scoreMax || this.totalPoint} active-change={false} parser={ value => value.split('.')[0] } vModel={this.state.scoreMin}  />
              <span class="sl-search-combo-divider"> ~ </span>
              <InputNumber min={1} active-change={false} parser={ value => value.replace(/[^\d]/g, '') } vModel={this.state.scoreMax} max={this.totalPoint} />
            </span>
          </sl-detail-list-item>
        </sl-detail-list>
      </div>
      <div class="modal-footer">
        <Button on-click={this.save} type="primary">确定</Button>
      </div>
    </div>
  }
}
